export const styles = {
  formWrapper: {
    width: '400px',
  },
  input: {
    my: 2,
    '&:last-of-type': {
      mb: 0,
    },
  },
  title: {
    my: 4,
  },
  registerWrapper: {
    mt: 3,
  },
  forgotPasswordButton: {
    my: 1,
  },
  registerNowLink: {
    fontWeight: 700,
    textDecoration: 'none',
    ml: 1,
  },
  accessNotice: {
    mt: 3,
    px: 1,
    textAlign: 'center',
  },
  accessNoticeTitle: {
    fontSize: '0.875rem',
    fontWeight: 700,
    lineHeight: 1.4,
    mb: 0.75,
    color: 'text.primary',
  },
  accessNoticeBody: {
    fontSize: '0.8rem',
    lineHeight: 1.55,
    color: 'text.secondary',
  },
};
